import { render, staticRenderFns } from "./PayoneerSummary.vue?vue&type=template&id=247e8e06&scoped=true&"
import script from "./PayoneerSummary.vue?vue&type=script&lang=js&"
export * from "./PayoneerSummary.vue?vue&type=script&lang=js&"
import style0 from "./PayoneerSummary.vue?vue&type=style&index=0&id=247e8e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247e8e06",
  null
  
)

export default component.exports